import React, { useState } from "react";
import { FileText } from "lucide-react";

/**
 * Renders a small thumbnail for an attachment URL.
 * - JPG/PNG/WEBP: renders inline
 * - PDF: tries to render the auto-generated first-page thumbnail; falls back to a PDF icon
 */
export default function AttachmentThumb({ url, size = 40, testid = "attachment-thumb" }) {
  const [pdfThumbFailed, setPdfThumbFailed] = useState(false);
  if (!url) return <span className="text-slate-400 text-xs">—</span>;

  const backend = process.env.REACT_APP_BACKEND_URL;
  const fullUrl = `${backend}${url}`;
  const isImage = /\.(jpe?g|png|webp)$/i.test(url);
  const isPdf = /\.pdf$/i.test(url);
  const pdfThumbUrl = isPdf ? `${backend}${url.replace(/\.pdf$/i, ".thumb.jpg")}` : null;

  const boxStyle = { width: size, height: size, objectFit: "cover", borderRadius: 4, border: "1px solid #e2e8f0", background: "#f8fafc" };
  const iconBox = (
    <div className="flex flex-col items-center justify-center text-slate-600 hover:text-slate-900 border border-slate-200 rounded"
         style={{ width: size, height: size }}>
      <FileText className="w-4 h-4" />
      <span className="text-[8px] font-semibold mt-0.5">PDF</span>
    </div>
  );

  let inner;
  if (isImage) {
    inner = <img src={fullUrl} alt="attachment" style={boxStyle} />;
  } else if (isPdf && !pdfThumbFailed) {
    inner = (
      <img
        src={pdfThumbUrl}
        alt="pdf preview"
        style={boxStyle}
        onError={() => setPdfThumbFailed(true)}
      />
    );
  } else if (isPdf) {
    inner = iconBox;
  } else {
    inner = iconBox;
  }

  return (
    <a href={fullUrl} target="_blank" rel="noreferrer" className="inline-block" title="Open attachment" data-testid={testid}>
      {inner}
    </a>
  );
}
